import { render, staticRenderFns } from "./CardPos.vue?vue&type=template&id=69a2b816"
import script from "./CardPos.vue?vue&type=script&lang=js"
export * from "./CardPos.vue?vue&type=script&lang=js"
import style0 from "./CardPos.vue?vue&type=style&index=0&id=69a2b816&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports